import { ReactNode } from 'react';

export type AccordionProps = {
  id: string;
  children?: ReactNode;
  allyTabToButton?: boolean;
  onSelect?: () => void;
  onAllExpanded?: () => void;
  onAllCollapsed?: () => void;
};

export type AccordionToggleProps = {
  title?: string;
  children: ReactNode;
  labelComponent?: ReactNode;
  ariaLabel?: string;
  hideWithCSSVisibility?: boolean;
  defaultExpanded?: boolean;
  openOverride?: boolean;
  isAccordionShell?: boolean;
  onClick?: (e: any, isExpanded: boolean) => void;
  headingElementType?: any;
};

export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_LEFT = 'ArrowLeft';
export const HOME = 'Home';
export const END = 'End';
export const ENTER = 'Enter';
